import { Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';

const LoginAttempts = ({ attempts }) => {
  if (!attempts) return null;

  return (
    <Col ht="40px" noFlex bg={theme.SECONDARY_10} marg="8px 0 0" wid="100%">
      <Row pad="8px" center>
        <Icon dimensions={22} type="warning" marg="0 9px 0 0" col={theme.SECONDARY} />

        <Text b2 col={theme.SECONDARY}>
          {3 - attempts} attempts left to lock your account
        </Text>
      </Row>
    </Col>
  );
};

export default LoginAttempts;
